export default "__VITE_ASSET__01ac5a1a__"